import { Component, OnInit, Input } from '@angular/core';
import { SelectOption } from '../../globals';
import { Utils } from '../../util';

export class Autocomplete<T extends string | number>{
  constructor(
    public id: string,
    public label: string,
    public items: SelectOption<T>[],
    private onChange?: (value: Autocomplete<T>['value']) => (void | Promise<void>),
  ){}
  
  active: boolean = false;
  showingItems: Autocomplete<T>['items'] = [];
  inputText: string = '';

  value: T | null = null;

  onIconClick(){
    if(this.active) this.inputText = '';
    (document.getElementById(this.id) || {focus: () => {}}).focus();
  }
  async onFocus(){
    await Utils.Time.sleep(200);
    this.onInput();
    this.active = true;
  }
  async onBlur(){
    await Utils.Time.sleep(200);
    this.active = false;
  }
  onInput(){
    this.showingItems = [];
    for(let item of this.items){
      if(this.showingItems.length > 100) break;
      //if(!this.inputText || item.name.toLowerCase().includes(this.inputText.toLowerCase())) this.showingItems.push(item);
      if(!this.inputText || Utils.String.wildcardMatch(item.name, this.inputText)) this.showingItems.push(item);
    }
    let item = this.items.find(item => item.name == this.inputText);
    this.value = item && item.value || null;
    this.onChange && this.onChange(this.value);
  }
  onSelect(name: string){
    this.inputText = name;
    this.onInput();
  }

  get labelClass(){
    let activeClass = '';
    if(this.active || !!this.inputText) activeClass = 'active';
    let colorClass = 'greenColor';
    if(!this.inputText) colorClass = '';
    else if(this.value == null) colorClass = 'redColor';
    return `${activeClass} ${colorClass}`;
  }

  setByValue(value: T){
    let item = this.items.find(item => item.value == value);
    this.onSelect(item && item.name || '');
  }
  clear(){
    this.inputText = '';
    this.onInput();
  }

}

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.css']
})
export class AutocompleteComponent implements OnInit {

  @Input() instance?: Autocomplete<any>;

  constructor() { }

  ngOnInit(): void {
  }

}
